<template>
<div id="page-templates" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Templates" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-flex xs12 style="margin-right: 5px" justify-end row fill-height>

                            <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout Campos.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-flex>

                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="500px" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >{{
                        update ? "edit" : "add"
                      }}</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Template</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>

                                <v-card-text>
                                    <v-form ref="form" lazy-validation>
                                        <v-container grid-list-md>
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-text-field label="Nombre" v-model="model.nombre" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field label="Descripción" v-model="model.descripcion" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-switch v-model="model.es_factura" :label="'Es template para facturas? '+ (model.es_factura?'SI':'NO')" >
                                                    </v-switch>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field label="Selecciona el archivo" @click='pickFile' v-model='model.name_file' :readonly="true"  prepend-icon='attach_file'></v-text-field>
                                                    <input type="file" style="display: none" ref="file_input" accept=".docx" @change="onFilePicked" >
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>

                                    <v-btn @click.native="modal = false; reset();" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" @click.native="update ? updateTemplate() : saveTemplate()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="templates.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="getTemplate(props.row.id_template)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteTemplate(props.row.id_template)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    created: function () {
        this.model.cliente = this.$local_storage.get("id_cliente");
        this.URL = this.$hostname + "catalogos/templates/";
        //this.model.cliente = 52;
        this.getTemplates();
        this.getCamposLayout();
    },
    data() {
        return {
            URL: "",
            fab: false,
            name: "datagrid",
            columns: [
                "nombre",
                "descripcion",
                "actions"
            ],
            show_loading: true,
            options: {
                filterable: ["nombre"],
                sortable: ["nombre"],

                headings: {
                    nombre: "Nombre",
                    descripcion: "Descripción",
                    actions: "Operaciones"
                }
            },
            show_loading: true,
            breadcrumbs: [
                {
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Templates",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            update: false,
            paises: [],
            estados_completos: [],
            estados: [],
            model: {
                nombre: "",
                descripcion: "",
                es_factura: false,
                file: "",
                cliente: "",
                name_file: "",
            },
            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",
            templates: {
                items: []
            },
            camposLayout: [{
                header: '[header]',
                clave: '[clave]',
            }, ],
            encabezadoLayout: {
                header: 'header',
                clave: 'clave',
            },
        };
    },

    methods: {
        getCamposLayout: function () {
            axios
                .get(this.URL + "campos_doc/ ")
                .then(response => {
                    this.camposLayout = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los templates.",
                        footer: ""
                    });
                });
        },
        pickFile() {
            this.$refs.file_input.click()
        },
        onFilePicked(e) {
            const files = e.target.files;

            if (files[0] !== undefined) {
                this.model.name_file = files[0].name

                if (this.model.name_file.lastIndexOf('.') <= 0) {
                    return false;
                }

                const fr = new FileReader()
                fr.readAsDataURL(files[0])

                fr.addEventListener('load', () => {
                    this.model.file = fr.result; // this is an image file that can be sent to server...
                })
            }

        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.update = false;
            } else
                this.update = true;
            
            this.modal = true;
            this.reset();
        },
        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.es_factura = false;
            this.model.cliente = this.$local_storage.get("id_cliente");            
        },
        getTemplates: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(this.URL + "list_cliente/", {
                    'cliente': this.model.cliente
                })
                .then(response => {
                    this.templates.items = response.data;
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los templates.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });
        },
        saveTemplate: function () {                        
            if (this.model.file == ""){
                this.$swal({
                    type: "error",
                    title: "Cuidado",
                    text: "Debe seleccionar un archivo. Favor de verificar",
                    footer: ""
                });
            } else if (this.$refs.form.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                axios
                    .post(this.URL, this.model)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El template se creó correctamente.",
                            footer: ""
                        });

                        this.modal = false;                        
                        this.getTemplates();
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al crear el template",
                            footer: ""
                        });
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        getTemplate: function (id_template) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            axios
                .get(this.URL + id_template + "/")
                .then(response => {
                    this.model.nombre = response.data.nombre;
                    this.model.id_template = response.data.id_template;
                    this.model.descripcion = response.data.descripcion;
                    this.model.es_factura = response.data.es_factura;                    

                    this.$root.$dialogLoader.hide();
                    this.openModal(2);
                })
                .catch(error => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el template",
                        footer: ""
                    });
                });
        },
        updateTemplate: function () {
            let id_template = this.model.id_template;

            if (this.$refs.form.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');  
                var modelCopy = this.model;
                if (modelCopy.file == ""){
                    delete(modelCopy.file);
                }                
                
                axios                    
                    .put(this.URL + id_template + "/", modelCopy)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El template se actualizó correctamente.",
                            footer: ""
                        });
                        
                        this.getTemplates();
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al actualizar el template",
                            footer: ""
                        });
                    });
            }
        },
        deleteTemplate: function (id_template) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.URL + id_template + "/")
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El template se eliminó correctamente.",
                                footer: ""
                            });                            
                            this.getTemplates();
                        })
                        .catch(error => {
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el template",
                                footer: ""
                            });
                        });
                }
            });
        }, 
        reset() {
            try {
                const input = this.$refs.file_input;
                if (input != undefined){
                    input.type = 'text';
                    input.type = 'file';
                    this.model.name_file = '';   
                }                
            } catch (error) {
                console.log(error);
            }            
        },
    }
};
</script>
